$(document).ready(function(e){

    $('body').on("click", "#eq-load-more-button", function(event){
        event.preventDefault();
        
        document.dispatchEvent(new Event('theme:loading:start'));

        var next_url = $(this).attr("href");
        next_url += (next_url.indexOf('?') < 0 ? '?' : "&") + 'view=ajax';
        $.get(next_url, function(data){
            $('.ProductList').append($(data).find('.ProductList').html());
            $('.load-more-button-wrap').html($(data).find('.load-more-button-wrap').html());

            document.dispatchEvent(new Event('theme:loading:end'));
        });
        return false;
    });
 

    $('body').on("submit", ".related_product_form", function(event){
        event.preventDefault();
        
        document.dispatchEvent(new Event('theme:loading:start'));
        var _this = $(this);
        var added_text = _this.find('button').attr("data-added_rel");    

        $.ajax({
            "method": "POST",
            "dataType": "json",
            "url": '/cart/add.js',
            "data":  _this.serialize(),
            "success": function(){
                _this.closest(".related-products__box").addClass('active');
                _this.find('button').html(added_text);

                $.get(window.location.href, function(html){
                    _this.closest(".related-products__wrap").html($(html).find('.related-products__wrap').html());
                });

                document.dispatchEvent(new Event('theme:loading:end'));

                document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                    bubbles: true
                })); 

                // $('.PageOverlay').addClass("is-visible");
                // $('#sidebar-cart').attr("aria-hidden","false");
                // $('#sidebar-cart').attr("tabindex","-1");
                // $('html').addClass("no-scroll");

            },
            "error": function(jqXHR, textStatus, errorThrown){
                var response = $.parseJSON(jqXHR.responseText);
                _this.append('<p class="alert">'+response.description+'</p>').find('.error').fadeIn();

                setTimeout(function(){
                    _this.find('.alert').fadeOut()
                },4000);
                            
                document.dispatchEvent(new Event('theme:loading:end'));
              }
        });
        
       
    });

    var lazyCounter = 0;

// POST commands to YouTube or Vimeo API
function postMessageToPlayer(player, command){
  if (player == null || command == null) return;
  player.contentWindow.postMessage(JSON.stringify(command), "*");
}

// When the slide is changing
function playPauseVideo(slick, control){
  var currentSlide, slideType, startTime, player, video;

  currentSlide = slick.find(".slick-current");
  slideType = currentSlide.attr("data-video_type");
  player = currentSlide.find("iframe").get(0);
  startTime = 0;

  if (slideType === "vimeo") {
    switch (control) {
      case "play":
        if ((startTime != null && startTime > 0 ) && !currentSlide.hasClass('started')) {
          currentSlide.addClass('started');
          postMessageToPlayer(player, {
            "method": "setCurrentTime",
            "value" : startTime
          }); 
        }
        postMessageToPlayer(player, {
          "method": "play",
          "value" : 1
        });
        break;
      case "pause":
        postMessageToPlayer(player, {
          "method": "pause",
          "value": 1
        });
        break;
    }
  } else if (slideType === "youtube") {
    switch (control) {
      case "play":
        postMessageToPlayer(player, {
          "event": "command",
          "func": "unmute"
        });
        postMessageToPlayer(player, {
          "event": "command",
          "func": "playVideo"
        });
        break;
      case "pause":
        postMessageToPlayer(player, {
          "event": "command",
          "func": "pauseVideo"
        });
        break;
    }
  } else if (slideType === "video") {
    video = $(currentSlide).find('video')[0];
    console.log("sssss sss");
    if (video != null) {
      if (control === "play"){
        video.play();
      } else {
        video.pause();
      }
    }
  }
}


    if($('.js-product-main-slider').length > 0) {
        setTimeout(function() {
            $('.js-product-main-slider').on("init", function(slick){
                slick = $(slick.currentTarget);
                setTimeout(function(){
                  playPauseVideo(slick,"play");
                }, 1000);
              });
              $('.js-product-main-slider').on("beforeChange", function(event, slick) {
                slick = $(slick.$slider);
                playPauseVideo(slick,"pause");
              });
              $('.js-product-main-slider').on("afterChange", function(event, slick) {
                slick = $(slick.$slider);
                playPauseVideo(slick,"play");
              });
        },1000);
        }


      $('body').on("click",".eq-custom-product-page-review, .eq-custom-product-page-review a",function(e){
          e.preventDefault();
          var header_height = $('header').outerHeight();
          $("html, body").animate({scrollTop:$('.eq-product-review').offset().top - header_height - 30}, 500, 'swing');
      });


});